import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Modal } from '@forma/forma-ui-kit';
import CopyInput from '@/components/CopyInput';

import { apiErrorAtom } from '@/store/apiError';

import styles from './error-modal.module.css';

const tgUrl = process.env.TG_URL;
// const waUrl = process.env.WA_URL;
const email = process.env.CONTACT_EMAIL;

const ErrorModal = () => {
  const { t } = useTranslation();
  const [apiError, setApiError] = useAtom(apiErrorAtom);

  return (
    <Modal
      open={!!apiError}
      onClose={() => setApiError(null)}
      title={t('something_went_wrong')}
      width="580px"
    >
      <div className={styles.root}>
        <div className={styles.content}>
          <CopyInput label={`${t('error_code')}:`} value={apiError?.errorId || ''} />
        </div>
        <div className={classNames(styles.content, styles.flex)}>
          <div className={styles.contacts}>
            <div className={styles.contactsTitle}>
              {t('something_went_wrong_description')}:
            </div>
            <ul className={styles.contactsList}>
              <li><a className={styles.link} href={tgUrl} target="_blank" rel="noreferrer">Telegram</a></li>
              {/*<li><a className={styles.link} href={waUrl} target="_blank" rel="noreferrer">WhatsApp</a></li>*/}
              <li><a className={styles.link} href={`mailto:${email}`}>{email}</a></li>
            </ul>
          </div>
          <img src="/images/trial-lock.svg" className={styles.image} alt={t('something_went_wrong')} />
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
